import { render, staticRenderFns } from "./AddPower.vue?vue&type=template&id=acfc1cf6&scoped=true&"
import script from "./AddPower.vue?vue&type=script&lang=js&"
export * from "./AddPower.vue?vue&type=script&lang=js&"
import style0 from "./AddPower.vue?vue&type=style&index=0&id=acfc1cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfc1cf6",
  null
  
)

export default component.exports